// FloatLabel Components
export const FloatLabel = (() => {
	const FLOAT_SELECTOR = "input, textarea, select";
	const FLOAT_CLASS = "label-is-floating";

	const CONTAINER_SELECTORS = [".field_sublabel_below:not(.gfield--type-checkbox)", ".gform-grid-col", ".field_sublabel_above:not(:has(.ginput_complex))", ".has-floating-label"];

	// Config par défaut
	let config = {
		ignoredTypes: ["checkbox", "radio", "hidden"],
		ignoredTags: [], // ex: ["TEXTAREA"]
	};

	const getContainer = (el) => {
		for (const selector of CONTAINER_SELECTORS) {
			const container = el.closest(selector);
			if (container) return container;
		}
		// fallback : si aucun container spécial, on prend le parent <form>
		return el.closest("form") || el.parentElement;
	};

	const isValidField = (el) => !config.ignoredTypes.includes(el.type) && !config.ignoredTags.includes(el.nodeName);

	const toggleFloat = (el, force) => {
		if (!isValidField(el)) return;

		const container = getContainer(el);
		if (!container) return;

		if (force !== undefined) {
			container.classList.toggle(FLOAT_CLASS, force);
		} else {
			container.classList.toggle(FLOAT_CLASS, !!el.value || el === document.activeElement);
		}
	};

	const handleFocus = (e) => toggleFloat(e.target, true);
	const handleBlur = (e) => toggleFloat(e.target, !!e.target.value);

	const bindEvents = (container) => {
		const fields = container.querySelectorAll(FLOAT_SELECTOR);

		fields.forEach((field) => {
			if (!isValidField(field)) return;

			if (!field.dataset.floatBound) {
				field.addEventListener("focus", handleFocus);
				field.addEventListener("blur", handleBlur);
				field.dataset.floatBound = "true";
			}
		});
	};

	const processContainer = (container) => {
		const fields = container.querySelectorAll(FLOAT_SELECTOR);

		fields.forEach((field) => {
			if (!isValidField(field)) return;
			toggleFloat(field);
		});

		bindEvents(container);
	};

	const init = (options = {}) => {
		// Merge intelligent
		if (options.ignoredTypes) {
			config.ignoredTypes = [...new Set([...config.ignoredTypes, ...options.ignoredTypes])];
		}
		if (options.ignoredTags) {
			config.ignoredTags = [...new Set([...config.ignoredTags, ...options.ignoredTags])];
		}

		// Cible d’abord les Gravity Forms
		let forms = document.querySelectorAll(".gform_wrapper");

		// Si aucun Gravity Form, fallback sur tous les forms
		if (forms.length === 0) {
			forms = document.querySelectorAll("form");
		}

		forms.forEach((form) => {
			const containers = form.querySelectorAll(CONTAINER_SELECTORS.join(", "));
			containers.forEach(processContainer);

			// Observer limité à ce form pour les ajouts dynamiques
			const observer = new MutationObserver((mutations) => {
				for (const mutation of mutations) {
					mutation.addedNodes.forEach((node) => {
						if (!(node instanceof HTMLElement)) return;

						if (node.matches?.(CONTAINER_SELECTORS.join(", "))) {
							processContainer(node);
						}

						const newContainers = node.querySelectorAll?.(CONTAINER_SELECTORS.join(", "));
						newContainers?.forEach(processContainer);
					});
				}
			});

			observer.observe(form, { childList: true, subtree: true });
		});
	};

	// Auto-init
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", () => init());
	} else {
		init();
	}

	return { init };
})();
